import locationsList from '../static-content/locale-menu.json';

export const checkUrlLocale = () => {
  //determine users location based off of url

  if (typeof window !== 'undefined') {
    const localeList = locationsList.locations.map(locale => locale.url);
    const currentUrl = new URL(window.location);
    const currentUrlPath = currentUrl.pathname.split('/');
    let currentGeo = sessionStorage.getItem('userGeoUrl') ? sessionStorage.getItem('userGeoUrl') : '';

    for (const locale of localeList) {
      if (currentUrlPath.includes(locale)) {
        const foundLocale = locationsList.locations.find(l => l.url === locale);
        sessionStorage.setItem('userLocation', foundLocale.displayLocation);
        sessionStorage.setItem('userGeoUrl', locale);
        localStorage.setItem('geoip_iso', foundLocale.geoIso_location[0]);
        currentGeo = '/' + locale;
        break;
      } else {
        sessionStorage.setItem('userLocation', 'GLOBAL');
        sessionStorage.setItem('userGeoUrl', '');
        localStorage.setItem('geoip_iso', '');
      }
    }

    return `${currentGeo}`;
  } else {
    // This safeguard ensures that the function handles non-browser environments by returning an empty string.
    // This snippet was added to handle special cases like scanning in SEMRush, where currentGeo was returning as undefined and the created links would lead to a 404.
    // In production environments, 'window' will always be defined, so this part of the code won't have any effect.
    return '';
  }
};
